import React, { useState } from "react";
import "../App.css";
import info from '../assets/info.png';

const WeeklyTable = ({ filterby }) => {
    const hoursOptions = ["4hrs", "6hrs", "8hrs", "10hrs", "12hrs"];
    const [selectedHours, setSelectedHours] = useState(
        Array(5).fill({ Monday: "8hrs", Tuesday: "8hrs", Wednesday: "8hrs", Thursday: "8hrs", Friday: "8hrs", Saturday: "8hrs" })
    );

    const handleChange = (day, index, value) => {
        const updatedHours = [...selectedHours];
        updatedHours[index] = { ...updatedHours[index], [day]: value };
        setSelectedHours(updatedHours);
    };

    return (
        <div className="w-full flex justify-center">
            
            <div className="w-full max-w-full p-5 bg-white shadow-lg rounded-lg overflow-x-auto custom-scrollbar">
                <table className="w-full min-w-[1000px] border-collapse">
                    <thead>
                        <tr className="border-b border-gray-300 text-[#900] bg-[#F9FAFB]">
                            <th className="p-3 pl-9 w-[20%] text-start">Employee Name</th>
                            <th className="p-3 w-[10%] text-start">Total Hours</th>
                            <th className="p-3 w-[15%] text-start">Total Diem</th>
                            <th className="p-3 w-[10%] text-start">Monday</th>
                            <th className="p-3 w-[10%] text-start">Tuesday</th>
                            <th className="p-3 w-[10%] text-start">Wednesday</th>
                            <th className="p-3 w-[10%] text-start">Thursday</th>
                            <th className="p-3 w-[10%] text-start">Friday</th>
                            <th className="p-3 w-[15%] text-start">Saturday</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: 5 }).map((_, index) => (
                            <tr key={index} className="border-b border-gray-200">
                                <td className="p-3 font-semibold text-start">
                                    <div className="flex gap-2 items-center">
                                        <div>
                                            <div className="flex items-center gap-4">
                                                <span>RUBEN BELTRAN</span>
                                                <span
                                                    className="px-2 py-1 text-[#8B1818] text-sm font-medium"
                                                    style={{
                                                        background: "rgba(139, 24, 24, 0.10)",
                                                        borderRadius: "9999px"
                                                    }}
                                                >
                                                    435
                                                </span>
                                            </div>
                                            <div className="text-sm font-normal text-gray-500">Supervisor</div>
                                        </div>
                                        <img src={info} alt="Info" className="w-4 h-4" />
                                    </div>
                                </td>
                                <td className="p-3 text-gray-900 text-center">49.0</td>
                                <td className="p-3 text-gray-900 text-center">$600.0</td>
                                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(day => (
                                    <td key={day} className="p-3 text-center">
                                        <select
                                            className="p-1 border rounded bg-[#F9FAFB] focus:outline-none"
                                            value={selectedHours[index][day]}
                                            onChange={(e) => handleChange(day, index, e.target.value)}
                                        >
                                            {hoursOptions.map(option => (
                                                <option key={option} value={option}>{option}</option>
                                            ))}
                                        </select>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default WeeklyTable;
